// Swiper documentation: https://swiperjs.com/swiper-api
// possible imports: A11y, Autoplay, Controller, EffectCards, EffectCoverflow, EffectCreative, EffectCube, EffectFade, EffectFlip, FreeMode, Grid, HashNavigation, History, Keyboard, Manipulation, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    Autoplay,
    Scrollbar,
    FreeMode,
    EffectFade
} from 'swiper/modules';

jQuery(document).ready(function($){

    const videoSubmoduleSwipers = $('.videos-submodule__swiper');
    videoSubmoduleSwipers.each((i, el) => {
        $(el).addClass(`videos-submodule__swiper-${i}`);

        let mobileSlidesPerView = $(el).attr('data-mobile-slides-per-view');

        let pagination = {
            el: $(`.videos-submodule__swiper-${i} .videos-submodule__controls__pagination`).get(0),
            type: "fraction",
        };
        let navigation = {
            nextEl: $(`.videos-submodule__swiper-${i} .videos-submodule__controls__next`).get(0),
            prevEl: $(`.videos-submodule__swiper-${i} .videos-submodule__controls__prev`).get(0),
        };

        let videoSubmoduleSwiper = new Swiper('.videos-submodule__swiper-' + i, {
            modules: [Navigation, Pagination],
            direction: 'horizontal',
            spaceBetween: 20,
            loop: false,
            slidesPerView: mobileSlidesPerView,
            pagination: pagination,
            navigation: navigation,
    
            breakpoints: {
                // when window width is >= breakpoint
                768: {
                    enabled: false
                },
            },

        });
    })


    const allCustomTestimonialSwipers = $('.custom-testimonials__swiper');
    allCustomTestimonialSwipers.each((i, el) => {
        $(el).addClass(`custom-testimonials__swiper-${i}`);
        let section = $(el).parent().parent('section');

        let testimonialSwiper = new Swiper('.custom-testimonials__swiper-' + i, {
            modules: [Navigation, Pagination, EffectFade],
            // Optional parameters
            loop: false,
            spaceBetween: 20,
            slidesPerView: 1,
            slidesPerGroup: 1,
            autoHeight: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
    
            pagination: {
                el: '.custom-testimonials__controls__pagination',
                type: "bullets",
                clickable: true
            },

            on: {
                afterInit: function () {

                },
              }
        });
    })


    const allCustomCardsSwipers = $('.custom-cards__swiper');
    allCustomCardsSwipers.each((i, el) => {
        $(el).addClass(`custom-cards__swiper-${i}`);

        let swiperWrapper = $(el).parent('.custom-cards');
        let mobileCardsPerView = swiperWrapper[0].style.getPropertyValue('--number-of-columns-mobile').trim();

        let customCardSwiper = null;

        function initCustomCardSwiper() {
            if (window.innerWidth < 768) {
                if (!customCardSwiper) {
                    customCardSwiper = new Swiper(`.custom-cards__swiper-${i}`, {
                        modules: [Pagination],
                        direction: 'horizontal',
                        loop: true,
                        spaceBetween: 20,
                        slidesPerView: mobileCardsPerView,
                        grabCursor: true,
                        autoHeight: false,
                        pagination: {
                            el: '.custom-cards__controls__pagination',
                            type: 'bullets',
                            clickable: true,
                        },
                    });
                }
            } else {
                if (customCardSwiper) {
                    customCardSwiper.destroy(true, true);
                    customCardSwiper = null;
                }
            }
        }

        initCustomCardSwiper();
        window.addEventListener('resize', initCustomCardSwiper);
    });

});
